import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";

export default function BoardUpload({ files, onChange }) {
  const [busy, setBusy] = useState(false);
  const add = async (e) => {
    const picked = Array.from(e.target.files || []).slice(0, 4 - files.length);
    e.target.value = "";
    if (!picked.length) return;
    setBusy(true);
    const out = [...files];
    for (const f of picked) {
      const fd = new FormData();
      fd.append("file", f);
      try { const r = await api.post("/uploads/board", fd); out.push(r.data); }
      catch (err) { toast.error(err?.response?.data?.detail || `Upload failed: ${f.name}`); }
    }
    onChange(out);
    setBusy(false);
  };
  return (
    <div data-testid="board-upload">
      <label className={`flex items-center justify-center gap-2 text-xs font-semibold rounded-xl border border-dashed px-4 py-3 cursor-pointer transition-colors ${files.length >= 4 ? "opacity-40 pointer-events-none" : "border-[#334155] text-slate-400 hover:border-emerald-500/50 hover:text-emerald-300"}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ImagePlus className="w-4 h-4" />}
        Whiteboard photos / PDF (optional, up to 4)
        <input data-testid="board-upload-input" type="file" accept="image/*,application/pdf" multiple className="hidden" onChange={add} />
      </label>
      {files.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {files.map((f, i) => (
            <span key={f.path} className="inline-flex items-center gap-1 text-[11px] bg-emerald-500/10 text-emerald-300 border border-emerald-500/30 rounded-full pl-2.5 pr-1 py-0.5" data-testid={`board-file-${i}`}>
              {f.name}
              <button onClick={() => onChange(files.filter((x) => x.path !== f.path))} className="hover:text-white"><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
